<div
  class="flex max-h-screen sm:h-screen relative overflow-y-auto md:overflow-hidden bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-primary)]">
  @if (shell.showAccessAlert) {
  <app-alert
    [title]="shell.accessAlertTitle"
    [message]="shell.accessAlertMessage"
    [type]="shell.accessAlertType"
    [duration]="4200"
    [token]="shell.accessAlertToken"
  ></app-alert>
  }
  @if (betaNotice.visible) {
  <app-beta-notice-modal
    [daysRemaining]="betaNotice.daysRemaining"
    [expired]="betaNotice.expired"
    (close)="betaNotice.dismiss()"
  ></app-beta-notice-modal>
  }
  @if (shell.shouldShowTrialNotice) {
    <app-trial-status-badge
      [message]="shell.trialNoticeMessage"
      [expired]="!!shell.trialInfo?.expired"
      [daysRemaining]="shell.trialInfo?.days_remaining ?? null"
    ></app-trial-status-badge>
  }
  @if (shell.showMobileBackdrop) {
  <div
    class="fixed inset-0 bg-[var(--color-gray-900)]/30 z-[1990]"
    (click)="shell.toggleMenuExpanded()"
    aria-hidden="true"
  ></div>
  }
  <!-- Sidebar Normal o Backoffice condicionalmente -->
  @if (!shell.isBackofficeMode) {
  <!-- Menú izquierdo normal -->
  <div
    data-onboarding="dashboard-navigation-menu"
    class="fixed inset-y-0 left-0 bg-[var(--color-brand-400)] dark:bg-[var(--color-dark-bg-primary)] border-r border-[var(--color-gray-200)] dark:border-[var(--color-gray-700)] flex flex-col transition-all duration-100"
    [ngClass]="shell.primarySidebarClassMap">
    <!-- expandido -->
    @if (shell.isMenuExpanded) {
    <div class="flex items-center justify-between pl-6 pr-4 pt-7 pb-4">
      <div class="flex items-center">
        <a href="/" (click)="$event.preventDefault(); shell.openHome()">
          <img src="assets/images/Ardia-Logo.svg" alt="ARDIA" class="h-7 w-auto cursor-pointer" />
        </a>
      </div>
      <button (click)="shell.toggleMenuExpanded()"
        class="w-5 h-5 flex items-center justify-center rounded cursor-pointer hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10 p-3 group">
        <fa-icon [icon]="faChevronLeft"
          class="text-base text-[var(--color-text-100)] dark:text-[var(--color-text-100)] group-hover:text-[var(--color-text-300)]"></fa-icon>
      </button>
    </div>

    <div class="flex flex-col h-full px-2 space-y-1 mt-8">
      @if (!shell.isLoggingOut) {
      <app-sidebar-navigation-group
        [group]="dashboardPrimaryGroup"
        variant="backoffice-expanded"
        [currentSection]="shell.activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="shell.onDashboardNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
      }
    </div>

    <!-- Footer -->
    <div class="flex-shrink-0 px-2 pb-4 mt-auto space-y-1">
      @if (!shell.isLoggingOut) {
      <app-sidebar-navigation-group
        [group]="dashboardFooterGroup"
        variant="backoffice-expanded"
        [currentSection]="shell.activeMenuSection"
        [separatorClass]="'h-px bg-white/20 my-2'"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="shell.onDashboardNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
      }
    </div>
    } @else if (!shell.isMobile) {
    <!-- colapsado -->
    <div class="pt-5 flex items-center justify-center mb-2">
      <a href="/" (click)="$event.preventDefault(); shell.openHome()">
        <img src="assets/images/Ardia-Logo-Colapsado.svg" alt="ARDIA" class="h-10 w-auto cursor-pointer" />
      </a>
    </div>

    <div class="flex flex-col h-full space-y-1">
      <button (click)="shell.toggleMenuExpanded()"
        class="w-5 h-5 flex items-center justify-center rounded cursor-pointer hover:bg-[var(--color-brand-100)] dark:hover:bg-[var(--color-white)]/10 p-3 group mx-auto mt-1 mb-2"
        title="Expandir menú">
        <fa-icon [icon]="faChevronRight"
          class="text-base text-[var(--color-text-100)] dark:text-[var(--color-text-100)] group-hover:text-[var(--color-text-300)]"></fa-icon>
      </button>

      @if (!shell.isLoggingOut) {
      <app-sidebar-navigation-group
        [group]="dashboardPrimaryGroup"
        variant="backoffice-collapsed"
        [currentSection]="shell.activeMenuSection"
        [separatorClass]="''"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="shell.onDashboardNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
      }
    </div>

    <!-- Footer -->
    <div class="flex-shrink-0 mt-auto pb-4 space-y-1">
      @if (!shell.isLoggingOut) {
      <app-sidebar-navigation-group
        [group]="dashboardFooterGroup"
        variant="backoffice-collapsed"
        [currentSection]="shell.activeMenuSection"
        [separatorClass]="'h-px bg-white/20 my-2'"
        [titleClass]="''"
        [itemsClass]="'space-y-1'"
        (itemSelected)="shell.onDashboardNavigationItemClick($any($event))"
      ></app-sidebar-navigation-group>
      }
    </div>
    }
  </div>
  } @else {
  <!-- Sidebar de Backoffice - Solo Inicio y Perfil -->
  <app-sidebar-backoffice></app-sidebar-backoffice>
  }

  <div class="fixed top-0 left-0 right-0 bg-[var(--color-white)] dark:bg-[var(--color-dark-bg-primary)] z-[11000]"
    [ngClass]="{ hidden: !shell.isMobile }">
    <div class="px-4 h-full flex items-center justify-between relative gap-2">
      <div class="flex items-center justify-start pt-2 relative z-10 shrink-0">
        <button (click)="shell.toggleMenuExpanded()"
          data-onboarding="dashboard-menu-toggle"
          class="w-8 h-8 bg-[var(--color-brand-500)] rounded-xl flex items-center justify-center hover:bg-[var(--color-brand-700)] transition-colors cursor-pointer">
          <fa-icon [icon]="faBars" class="text-white"></fa-icon>
        </button>
          <div class="relative inline-block" [ngClass]="{ invisible: !shell.showMobileSidebarToggle }">
          <button (click)="shell.toggleSidebar()"
            class="text-[var(--color-gray-600)] hover:text-[var(--color-black)] cursor-pointer dark:text-[var(--color-white)] dark:hover:text-[var(--color-white)] px-3 py-3 text-xl"
            data-toggle-sidebar="true">
            <fa-icon [icon]="faBarsSort"></fa-icon>
          </button>
        </div>
      </div>

      <div class="absolute inset-x-16 sm:inset-x-20 pt-2 flex items-center justify-center pointer-events-none">
        @if (shell.activeMenuSection === "profile" || shell.activeMenuSection === "company") {
        <h2
          class="block w-full truncate text-center text-base sm:text-lg font-semibold text-[var(--color-neutral-800)] dark:text-[var(--color-white)] py-2">
          @if (shell.activeMenuSection === "profile") {
          Mis datos personales
          } @else if (shell.activeMenuSection === "company") {
          Datos de mi empresa
          }
        </h2>
        }
      </div>

      <div class="flex items-center justify-end gap-2 pt-2 relative z-10 shrink-0 min-w-0">
        <app-profile-menu [showNameOnMobile]="false" [compactMode]="true"></app-profile-menu>
      </div>
    </div>
  </div>

  <!-- Sidebar secundario - Mostrar en chats o en settings (settings solo modo normal, NO backoffice) -->
  @if (!shell.isBackofficeMode) {
  <div class="h-full" [ngClass]="shell.secondarySidebarClassMap" [style.display]="shell.showHome ? 'none' : 'block'">
    <app-sidebar-menu [ngClass]="{ hidden: shell.sidebarContent !== 'menu' || !shell.showSidebarMenu }">
    </app-sidebar-menu>
    <app-sidebar-profile [ngClass]="{
          hidden:
            (shell.sidebarContent !== 'profile' && !shell.isSettingsRoute()) ||
            shell.isPersonalProfileRoute(),
        }">
    </app-sidebar-profile>
  </div>
  }

  <!-- Contenido principal -->
  <div class="h-full flex-1 min-w-0 relative dark:bg-[var(--color-dark-bg-primary)] transition-all duration-100 flex flex-col" [ngClass]="shell.mainContentClassMap">
    @if (shell.shouldShowTopNavbar) {
    <app-top-navbar></app-top-navbar>
    }

    <div class="flex-1 w-full min-h-0 transition-[padding] duration-100" [ngClass]="shell.contentContainerClassMap">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-search-chat></app-search-chat>

  <div class="onboarding-floating-anchor" data-onboarding="floating-anchor" aria-hidden="true"></div>

  <!-- Botón flotante WhatsApp (sustituye al widget de HubSpot) -->
  <app-support-chat
    position="custom"
    [customPosition]="supportChatCustomPosition"
    buttonStyle="circular"
    buttonColor="success"
    size="medium"
    [showText]="false"
    buttonText="WhatsApp"
    iconType="whatsapp"
  ></app-support-chat>

  @if (onboardingTourService.isWelcomeVisible()) {
  <div class="onboarding-welcome fixed inset-0 z-[12000]">
    <div class="onboarding-welcome__backdrop absolute inset-0"></div>

    <div class="onboarding-welcome__content relative z-10 flex min-h-full items-center justify-center px-4 pb-28 pt-10">
      <div class="onboarding-welcome__card">
        <div class="onboarding-welcome__orb onboarding-welcome__orb--top"></div>
        <div class="onboarding-welcome__orb onboarding-welcome__orb--bottom"></div>

        <div class="onboarding-welcome__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" class="w-6 h-6" fill="none">
            <path d="M12 3l1.5 3.5L17 8l-3.5 1.5L12 13l-1.5-3.5L7 8l3.5-1.5L12 3z" fill="currentColor"></path>
            <path d="M18.5 14l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9.9-2.1z" fill="currentColor" opacity=".7"></path>
            <path d="M6 14.5l.8 1.9 1.9.8-1.9.8L6 20l-.8-1.9-1.9-.8 1.9-.8L6 14.5z" fill="currentColor" opacity=".5"></path>
          </svg>
        </div>

        <h2 class="onboarding-welcome__title">
          {{ onboardingTourService.getWelcomeTitle() }}
        </h2>
        <p class="onboarding-welcome__description">
          {{ onboardingTourService.getWelcomeDescription() }}
        </p>

        <button
          type="button"
          class="onboarding-welcome__primary"
          (click)="onboardingTourService.startFromWelcome()"
        >
          {{ onboardingTourService.getWelcomePrimaryActionLabel() }}
        </button>

      </div>
    </div>
  </div>
  }

  @if (onboardingTourService.isTourActive()) {
  <div class="onboarding-welcome__dock">
    <div class="onboarding-welcome__progress">
      <span class="onboarding-welcome__progress-eyebrow">
        PASO {{ onboardingTourService.getCurrentStepNumber() }} DE {{ onboardingTourService.getTotalSteps() }}
        <span class="onboarding-welcome__progress-current">
          · {{ onboardingTourService.getCurrentStepLabel() }}
        </span>
      </span>
      <div class="onboarding-welcome__progress-bar">
        <span
          class="onboarding-welcome__progress-fill"
          [style.width.%]="onboardingTourService.getProgressPercentage()"
        ></span>
      </div>
    </div>

    <div class="onboarding-welcome__dock-meta">
      <details class="onboarding-welcome__steps-dropdown">
        <summary class="onboarding-welcome__steps-toggle">
          <svg
            class="onboarding-welcome__steps-toggle-icon"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="onboarding-welcome__steps-toggle-badge">
            {{ onboardingTourService.getProgressPercentageLabel() }}
          </span>
        </summary>

        <div class="onboarding-welcome__steps-panel">
          @for (step of onboardingTourService.getDockSteps(); track step.id) {
          <button
            type="button"
            class="onboarding-welcome__step-item"
            [class.onboarding-welcome__step-item--current]="step.isCurrent"
            [disabled]="!step.canNavigate"
            (click)="onboardingTourService.jumpToStepFromDock(step.index)"
          >
            <span
              class="onboarding-welcome__step-icon"
              [class.onboarding-welcome__step-icon--done]="step.isCompleted"
              [class.onboarding-welcome__step-icon--current]="step.isCurrent"
              [class.onboarding-welcome__step-icon--pending]="!step.isCompleted && !step.isCurrent"
              aria-hidden="true"
            >
              @if (step.isCompleted) {
              <span class="onboarding-welcome__step-check">&#10003;</span>
              }
            </span>
            <span class="onboarding-welcome__step-copy">
              <span class="onboarding-welcome__step-title">
                Paso {{ step.number }}: {{ step.title }}
              </span>
              @if (step.isCurrent) {
              <span class="onboarding-welcome__step-status">Actual</span>
              }
            </span>
          </button>
          }
        </div>
      </details>
      <button
        type="button"
        class="onboarding-welcome__dock-button onboarding-welcome__dock-button--ghost"
        (click)="onboardingTourService.previousStep()"
        [disabled]="onboardingTourService.isPreviousDisabled()"
      >
        Anterior
      </button>
      @if (!onboardingTourService.isLastStep() && onboardingTourService.shouldShowDockContinueButton()) {
      <button
        type="button"
        class="onboarding-welcome__dock-button onboarding-welcome__dock-button--ghost"
        (click)="onboardingTourService.continueTour()"
        [disabled]="onboardingTourService.isContinueDisabled()"
      >
        Siguiente
      </button>
      }
      <button
        type="button"
        class="onboarding-welcome__dock-button onboarding-welcome__dock-button--primary"
        (click)="onboardingTourService.finishTour()"
      >
        Finalizar
      </button>
    </div>
  </div>
  }
</div>
